wbApp.controller('mobileAppSettingsCtrl', ['$scope', '$q', '$translate', 'tenantSettingSvc', 'notificationSvc', 
function ($scope, $q, $translate, tenantSettingSvc, notificationSvc) {

    const tabId = 11;
    
    let isActive = false;
    let loaded = false;

    $scope.modelOrig = {};
    $scope.model = {};
    $scope.isBusy = true;
    
    function loadData() {
        $scope.isBusy = true;
        tenantSettingSvc.getMobileAppSettings().$promise.then(function (result) {
            
            
            
            $scope.model = angular.copy(result);
            $scope.model.keywords = !result.keywords
                ? '' 
                : result.keywords.join(',');
            
            $scope.modelOrig = angular.copy($scope.model);
            $scope.isBusy = false;
        });
    }

    $scope.$on('refreshData', function (e, data) {
        if (isActive) {
            loadData();
        }
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === tabId) {
            if (!isActive) {
                isActive = true;

                if (!loaded) {
                    loadData();
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.onCancel = function () {
        loadData();
    }

    $scope.onModelSave = function (model) {
        if ($scope.isBusy) {
            return;
        }
        
        if (!$scope.detailIsUnchanged(model)) {
            $scope.isBusy = true;

            let dto = angular.copy(model);
            dto.keywords = !model.keywords
                ? ''
                : model.keywords.split(/[\s,]+/).filter(item => item !== '');
            
            tenantSettingSvc.updateMobileAppSettings(dto).$promise.then(function () {
                $scope.isBusy = false;
                loadData();
            }, function (errorResult) {
                $scope.isBusy = false;
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                    notificationSvc.translateError(errorResult));
            });
        }
    }

    $scope.detailIsUnchanged = function (model) {
        return angular.equals(model, $scope.modelOrig);
    }
}]);
